/**
 * Données structurées par défaut pour Schema.org
 * Utilisées pour compléter les rich snippets Google
 */

// La note agrégée vient désormais d'une seule source : voir @/constants/avisGoogle.
// Elle annonçait ici 4,9 sur 127 avis, publiés tels quels sur 8 pages, alors que la
// fiche Google en compte 20 avec une note de 5,0.
export { NOTE_AGREGEE_GOOGLE as DEFAULT_AGGREGATE_RATING } from '@/constants/avisGoogle';

// `DEFAULT_REVIEW` a été SUPPRIMÉ, et non corrigé. C'était un avis entièrement inventé —
// auteur « Client vérifié », texte « Service exceptionnel… » daté du 15/11/2024 — publié
// en données structurées sur 14 pages. Un faux témoignage ne se réécrit pas : il s'enlève.
// Les vrais avis sont servis par l'edge function get-google-reviews et affichés par
// GoogleReviewSection.

/**
 * Détails de livraison pour prestations sur site
 * Adapté pour services évènementiels (pas de livraison physique)
 */
export const DEFAULT_SHIPPING_DETAILS = {
  "@type": "OfferShippingDetails",
  "shippingRate": {
    "@type": "MonetaryAmount",
    "value": "0",
    "currency": "EUR"
  },
  "shippingDestination": {
    "@type": "DefinedRegion",
    "addressCountry": "FR",
    "addressRegion": ["Île-de-France"]
  },
  "deliveryTime": {
    "@type": "ShippingDeliveryTime",
    "handlingTime": {
      "@type": "QuantitativeValue",
      "minValue": "1",
      "maxValue": "14",
      "unitCode": "DAY"
    },
    "transitTime": {
      "@type": "QuantitativeValue",
      "minValue": "0",
      "maxValue": "0",
      "unitCode": "DAY"
    }
  }
};

/**
 * Politique de retour/annulation pour services évènementiels
 * Adapté pour prestations non remboursables
 */
export const DEFAULT_RETURN_POLICY = {
  "@type": "MerchantReturnPolicy",
  "applicableCountry": "FR",
  "returnPolicyCategory": "https://schema.org/MerchantReturnNotPermitted",
  "merchantReturnDays": 0,
  "returnMethod": "https://schema.org/ReturnByMail",
  "returnFees": "https://schema.org/ReturnFeesCustomerResponsibility"
};
